"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2100],{

/***/ 77474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wP": function() { return /* binding */ getDesktopBgImage; }
/* harmony export */ });
/* unused harmony export useDesktopBgStore */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31501);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66697);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70079);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32848);
/* harmony import */ var _MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60303);






var useDesktopBgStore = (0,zustand__WEBPACK_IMPORTED_MODULE_3__/* .create */ .Ue)(function(set) {
    return {
        bgImageProps: {},
        resetBgImage: function() {
            return set(function() {
                return {
                    bgImageProps: {}
                };
            });
        },
        updateBgImage: function(image) {
            return set(function() {
                return {
                    bgImageProps: getDesktopBgImage(image)
                };
            });
        }
    };
});
var getDesktopBgImage = function(image) {
    var commonProps = {
        backgroundRepeat: "no-repeat"
    };
    switch(image){
        case "PATTERN_1":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/pattern-1-desktop.png",
                backgroundSize: "100vw auto",
                backgroundPosition: "center 210px"
            }, commonProps);
        case "PATTERN_2":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/pattern-2-desktop.png",
                backgroundSize: "55vw auto",
                backgroundPosition: "right top"
            }, commonProps);
        case "PATTERN_2_ATOM":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/unstake-atom-bg.svg",
                backgroundSize: "100vw auto",
                backgroundPosition: "center top 100px"
            }, commonProps);
        case "PATTERN_3":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/pattern-3-desktop.png",
                backgroundSize: "100vw auto",
                backgroundPosition: "center"
            }, commonProps);
        case "PATTERN_3_ATOM":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/stake-atom-bg.svg",
                backgroundSize: "100vw auto",
                backgroundPosition: "center"
            }, commonProps);
        case "PATTERN_4":
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/pattern-4-desktop.png",
                backgroundSize: "75vw auto",
                backgroundPosition: "center top"
            }, commonProps);
        case "PATTERN_4_SMALL":
        default:
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                bgImage: "/images/pattern-4-desktop.png",
                backgroundSize: "50vw auto",
                backgroundPosition: "50% 60px"
            }, commonProps);
    }
};
var DesktopBg = function(param) {
    var pattern = param.pattern;
    var bgImageProps = useDesktopBgStore(function(store) {
        return store.bgImageProps;
    });
    var updateBgImage = useDesktopBgStore(function(store) {
        return store.updateBgImage;
    });
    var resetBgImage = useDesktopBgStore(function(store) {
        return store.resetBgImage;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        updateBgImage(pattern);
        return function() {
            return resetBgImage();
        };
    }, [
        updateBgImage,
        resetBgImage,
        pattern
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__/* .InDesktop */ .Fe, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            pos: "fixed",
            top: 0,
            left: 0,
            w: "100vw",
            h: "100vh",
            zIndex: -1
        }, bgImageProps))
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (DesktopBg);


/***/ }),

/***/ 41652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ StrategyApySimpleLineChart; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89874);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42928);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83838);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68866);
/* harmony import */ var _ui_utils_withNoSSR__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2781);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(77180);
/* harmony import */ var numbro__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69248);
/* harmony import */ var numbro__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(numbro__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SimpleLineChart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71712);











var StrategyApySimpleLineChart = (0,_ui_utils_withNoSSR__WEBPACK_IMPORTED_MODULE_2__/* .withNoSSR */ .X)(function(_param) {
    var apyList = _param.apyList, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "apyList"
    ]);
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslations */ .T_)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .useToken */ .dQ)("colors", [
        "brand-inactive"
    ]), 1), chartLineColor = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleLineChart__WEBPACK_IMPORTED_MODULE_4__/* .SimpleLineChart */ .t, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, props), {
        series: [
            {
                data: apyList.map(function(param) {
                    var y = param.y, date = param.date;
                    return {
                        y: y * 100,
                        name: (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(date, "yyyy - MM - dd")
                    };
                }),
                color: chartLineColor,
                label: t("APY % plotted over time")
            }, 
        ],
        lineColorAlphaBase: 0.4,
        height: 100,
        tooltipFormatter: function(param) {
            var y = param.y;
            return "".concat(numbro__WEBPACK_IMPORTED_MODULE_3___default()(y).format({
                mantissa: 1,
                trimMantissa: true
            }), "%");
        }
    }));
});


/***/ }),

/***/ 84661:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ TokenSelectionDrawer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61079);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89874);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64705);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66697);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31327);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(20427);
/* harmony import */ var _ui_components_Card__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99726);
/* harmony import */ var _ui_components_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60303);
/* harmony import */ var _ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64881);
/* harmony import */ var _ui_components_RotatingBg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48837);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68866);
/* harmony import */ var _ui_utils_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25966);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70079);













var TokenSelectionDrawer = function(_param) {
    var onClose = _param.onClose, isOpen = _param.isOpen, value = _param.value, onChange = _param.onChange, tokenList = _param.tokenList, tokenBalanceDict = _param.tokenBalanceDict, tokenDict = _param.tokenDict, skipConfirmation = _param.skipConfirmation, preferred = _param.preferred, theme = _param.theme, flexProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "onClose",
        "isOpen",
        "value",
        "onChange",
        "tokenList",
        "tokenBalanceDict",
        "tokenDict",
        "skipConfirmation",
        "preferred",
        "theme"
    ]);
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslations */ .T_)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(value), checkedToken = ref[0], setCheckedToken = ref[1];
    var defaultTokenList = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return !preferred ? tokenList : tokenList.filter(function(t) {
            return t !== preferred;
        });
    }, [
        preferred,
        tokenList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (!isOpen) {
            setCheckedToken(value);
        }
    }, [
        isOpen,
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawer */ .NH, {
        placement: "bottom",
        size: {
            base: "full",
            desktop: "md"
        },
        isOpen: isOpen,
        onClose: function() {
            return onClose();
        },
        scrollBehavior: "inside",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawerOverlay */ .Dx, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDragDrawerContent */ .Zt, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                bgColor: theme === "vvs" ? "vvs.bg" : "bg.card"
            }, flexProps), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawerHeader */ .BB, {
                        color: theme === "vvs" ? "text.vvs" : "text.normal",
                        children: t("Select token")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_2__/* .RenderInDesktop */ .Po, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawerCloseButton */ .M3, {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawerBody */ .M1, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                            gap: "16px",
                            direction: "column",
                            children: (preferred ? [
                                preferred
                            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(defaultTokenList)) : defaultTokenList).map(function(token, i) {
                                var tokenInfo = tokenDict[token];
                                var isChecked = token === checkedToken;
                                var balanceRet = tokenBalanceDict[token];
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_7__.Fragment, {
                                    children: [
                                        preferred && i === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            children: t("Preferred")
                                        }),
                                        theme === "vvs" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TokenSelectionCardVvs, {
                                            token: token,
                                            isChecked: isChecked,
                                            skipConfirmation: !!skipConfirmation,
                                            onClose: onClose,
                                            onChange: onChange,
                                            tokenInfo: tokenInfo,
                                            balanceRet: balanceRet,
                                            setCheckedToken: setCheckedToken
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TokenSelectionCard, {
                                            token: token,
                                            isChecked: isChecked,
                                            skipConfirmation: !!skipConfirmation,
                                            onClose: onClose,
                                            onChange: onChange,
                                            tokenInfo: tokenInfo,
                                            balanceRet: balanceRet,
                                            setCheckedToken: setCheckedToken
                                        }),
                                        preferred && i === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                                            children: t("Other")
                                        })
                                    ]
                                }, token);
                            })
                        })
                    }),
                    !skipConfirmation && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_ModalOrDrawer__WEBPACK_IMPORTED_MODULE_3__/* .ModalOrDrawerFooter */ .Un, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Button */ .zx, {
                            w: "full",
                            onClick: function() {
                                onChange(checkedToken);
                                onClose();
                            },
                            children: t("Confirm")
                        })
                    })
                ]
            }))
        ]
    });
};
var TokenSelectionCard = function(param) {
    var token = param.token, isChecked = param.isChecked, skipConfirmation = param.skipConfirmation, onClose = param.onClose, onChange = param.onChange, tokenInfo = param.tokenInfo, balanceRet = param.balanceRet, setCheckedToken = param.setCheckedToken;
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslations */ .T_)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_Card__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Z, {
        cursor: "pointer",
        display: "flex",
        mx: "0",
        my: "0",
        p: "16px",
        gap: "8px",
        isActive: isChecked,
        onClick: skipConfirmation ? function() {
            onChange(token);
            onClose();
        } : function() {
            return setCheckedToken(token);
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_RotatingBg__WEBPACK_IMPORTED_MODULE_4__/* .RotatingBg */ .N, {
                w: "48px",
                h: "48px",
                justify: "center",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(tokenInfo.Icon, {
                    width: "32px",
                    height: "32px"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .xu, {
                flex: "1",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                        textStyle: "h4Bold",
                        children: tokenInfo.name
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                        mt: "4px",
                        color: "text-light",
                        children: [
                            t("Wallet balance"),
                            ":",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                                as: "span",
                                textStyle: "bodyBold",
                                children: balanceRet.data ? (0,_ui_utils_format__WEBPACK_IMPORTED_MODULE_6__/* .formatTokenAmount */ .LH)(balanceRet.data, 2, tokenInfo.decimals) : "--"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Radio */ .Y8, {
                isChecked: isChecked,
                alignSelf: "flex-start"
            })
        ]
    });
};
var TokenSelectionCardVvs = function(param) {
    var token = param.token, isChecked = param.isChecked, skipConfirmation = param.skipConfirmation, onClose = param.onClose, onChange = param.onChange, tokenInfo = param.tokenInfo, balanceRet = param.balanceRet, setCheckedToken = param.setCheckedToken;
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslations */ .T_)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_Card__WEBPACK_IMPORTED_MODULE_1__/* .Card */ .Z, {
        cursor: "pointer",
        display: "flex",
        mx: "auto",
        minW: "255px",
        my: "0",
        p: "16px",
        gap: "8px",
        isActive: isChecked,
        variant: "vvs",
        onClick: skipConfirmation ? function() {
            onChange(token);
            onClose();
        } : function() {
            return setCheckedToken(token);
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
            flexDir: "column",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Flex */ .kC, {
                    gap: 1,
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(tokenInfo.Icon, {
                            width: "32px",
                            height: "32px"
                        }),
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                            textStyle: "h4Bold",
                            color: "text.vvs",
                            children: tokenInfo.name
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                    mt: "4px",
                    color: "vvs.textLight",
                    children: [
                        t("Wallet balance"),
                        ":",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .xv, {
                            as: "span",
                            textStyle: "bodyBold",
                            children: balanceRet.data ? (0,_ui_utils_format__WEBPACK_IMPORTED_MODULE_6__/* .formatTokenAmount */ .LH)(balanceRet.data, 2, tokenInfo.decimals) : "--"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 21101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ DepositAndWithdraw; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+skeleton@2.0.17_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/skeleton/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(28440);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+tabs@2.1.3_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/tabs/dist/index.esm.js
var tabs_dist_index_esm = __webpack_require__(43655);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+units@5.7.0/node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(51933);
// EXTERNAL MODULE: ./src/components/Balance/Balance.tsx
var Balance = __webpack_require__(26249);
// EXTERNAL MODULE: ./src/components/Info/Info.tsx
var Info = __webpack_require__(6967);
// EXTERNAL MODULE: ./src/components/InputCard/InputCard.tsx
var InputCard = __webpack_require__(95276);
// EXTERNAL MODULE: ./src/components/InputCard/InputCardStepper.tsx
var InputCardStepper = __webpack_require__(70093);
// EXTERNAL MODULE: ./src/components/StrategyApySimpleLineChart.tsx
var StrategyApySimpleLineChart = __webpack_require__(41652);
// EXTERNAL MODULE: ./src/config/paths.ts
var paths = __webpack_require__(71953);
// EXTERNAL MODULE: ./src/hooks/router.ts + 2 modules
var router = __webpack_require__(81554);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(61706);
// EXTERNAL MODULE: ../node_modules/.pnpm/tslib@2.4.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45813);
// EXTERNAL MODULE: ../node_modules/.pnpm/@ethersproject+bignumber@5.7.0/node_modules/@ethersproject/bignumber/lib.esm/bignumber.js
var bignumber = __webpack_require__(54815);
// EXTERNAL MODULE: ../node_modules/.pnpm/@tanstack+react-query@4.24.10_react-dom@18.2.0_react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(67496);
// EXTERNAL MODULE: ./src/providers/VenoSDKProvider.tsx
var VenoSDKProvider = __webpack_require__(29142);
;// CONCATENATED MODULE: ./src/hooks/useStrategyDepositTransactionFee.tsx





var useStrategyDepositTransactionFee = function(token) {
    var sdk = (0,VenoSDKProvider/* useVenoSDK */.ho)();
    var getFee = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (token !== "cro") return [
                    2,
                    bignumber/* BigNumber.from */.O$.from(0)
                ];
                return [
                    2,
                    sdk.CroYVault.estimateGasForDeposit()
                ];
            });
        });
        return function getFee() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref = (0,useQuery/* useQuery */.a)([
        "useStrategyDepositTransactionFee"
    ], getFee), stakeFee = ref.data;
    return stakeFee;
};

// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
// EXTERNAL MODULE: ./src/utils/bigNumberToNumber.ts
var bigNumberToNumber = __webpack_require__(19089);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(25966);
// EXTERNAL MODULE: ./src/utils/strategy.tsx
var strategy = __webpack_require__(92786);
// EXTERNAL MODULE: ./src/utils/urlHistory.ts
var urlHistory = __webpack_require__(59023);
;// CONCATENATED MODULE: ./src/utils/validators.ts

var decimalsValidator = function(value) {
    var maxDecimalsAllowed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 18;
    if (value && !new RegExp("^[0-9]+\\.?[0-9]{0,".concat(maxDecimalsAllowed, "}$")).test(value)) {
        if (new RegExp("\\.?[0-9]{".concat(maxDecimalsAllowed + 1, ",}$")).test(value)) {
            return i18n/* i18next.t */.z2.t("maximum {decimal} decimal places allowed", {
                decimal: maxDecimalsAllowed
            });
        } else {
            return i18n/* i18next.t */.z2.t("invalid format");
        }
    }
};
var balanceValidator = function(value, maxAmount) {
    if (maxAmount !== undefined && parseFloat(value) > maxAmount) {
        return i18n/* i18next.t */.z2.t("Insufficient Balance");
    }
};

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(70079);
// EXTERNAL MODULE: ./src/views/Strategy/DepositDrawer/useDepositDrawer.ts
var useDepositDrawer = __webpack_require__(66490);
// EXTERNAL MODULE: ./src/views/Strategy/ReceiveRows.tsx
var ReceiveRows = __webpack_require__(18902);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+hooks@2.0.11_react@18.2.0/node_modules/@chakra-ui/hooks/dist/index.esm.js
var hooks_dist_index_esm = __webpack_require__(19267);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+icon@3.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(93193);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 1 modules
var Card = __webpack_require__(99726);
// EXTERNAL MODULE: ../packages/icons/dist/esm/index.js + 53 modules
var esm = __webpack_require__(99784);
// EXTERNAL MODULE: ./src/components/TokenSelectionDrawer.tsx
var TokenSelectionDrawer = __webpack_require__(84661);
;// CONCATENATED MODULE: ./src/views/Strategy/TokenSelectionButton/StrategyTokenSelectionDrawer.tsx



var StrategyTokenSelectionDrawer = function(param) {
    var onClose = param.onClose, isOpen = param.isOpen, value = param.value, onChange = param.onChange, preferred = param.preferred;
    var tokenList = [
        "cro",
        "wcro",
        "lcro",
        "ferroLP", 
    ];
    var tokenBalanceDict = (0,strategy/* useDepositTokenBalances */.XW)();
    var tokenDict = strategy/* LiquidityStrategyTokenDict */.qn;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectionDrawer/* TokenSelectionDrawer */.X, {
        onClose: onClose,
        isOpen: isOpen,
        value: value,
        onChange: function(token) {
            return onChange(token);
        },
        tokenList: tokenList,
        tokenBalanceDict: tokenBalanceDict,
        tokenDict: tokenDict,
        preferred: preferred
    });
};

;// CONCATENATED MODULE: ./src/views/Strategy/TokenSelectionButton/index.tsx









var TokenSelectionButton = function(_param) {
    var value = _param.value, onChange = _param.onChange, preferred = _param.preferred, props = (0,_object_without_properties/* default */.Z)(_param, [
        "value",
        "onChange",
        "preferred"
    ]);
    var tokenSelectionDrawerDisclosure = (0,hooks_dist_index_esm/* useDisclosure */.qY)();
    var tokenInfo = strategy/* LiquidityStrategyTokenDict */.qn[value];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mx: "0",
                cursor: "pointer"
            }, props), {
                onClick: function(e) {
                    var ref;
                    tokenSelectionDrawerDisclosure.onOpen();
                    (ref = props.onClick) === null || ref === void 0 ? void 0 : ref.call(props, e);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tokenInfo.Icon, {
                        width: "30px",
                        height: "30px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: esm/* ArrowDown */.K5,
                        width: "22px",
                        height: "22px"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrategyTokenSelectionDrawer, {
                preferred: preferred,
                isOpen: tokenSelectionDrawerDisclosure.isOpen,
                onClose: tokenSelectionDrawerDisclosure.onClose,
                value: value,
                onChange: onChange
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/utils/zustandMiddleware.ts + 45 modules
var zustandMiddleware = __webpack_require__(7306);
// EXTERNAL MODULE: ../node_modules/.pnpm/zustand@4.3.5_react@18.2.0/node_modules/zustand/esm/index.mjs + 1 modules
var zustand_esm = __webpack_require__(32848);
;// CONCATENATED MODULE: ./src/views/Strategy/useStrategyStore.ts


var useStrategyStore = (0,zustand_esm/* create */.Ue)((0,zustandMiddleware/* resetWhenRouterChange */.G)(function() {
    return {
        amountStr: "",
        amountInputError: undefined,
        withdrawStr: "",
        withdrawInputError: undefined,
        depositToken: "cro",
        withdrawToken: "ferroLP"
    };
}));

;// CONCATENATED MODULE: ./src/views/Strategy/DepositAndWithdraw.tsx






















var DepositAndWithdraw = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var pathInfo = (0,router/* getPathInfo */.o$)((0,router/* useRealPathname */.ZD)());
    var tvl = (0,strategy/* useStrategyTvl */.qi)();
    var _data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                mb: 3,
                flexDir: "column",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                        children: t("{coin} liquidity strategy", {
                            coin: "CRO"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Skeleton */.Od, {
                        color: "text-light",
                        isLoaded: tvl.data !== undefined,
                        textStyle: "caption",
                        children: [
                            (0,format/* formatNumber */.uf)((_data = tvl.data) !== null && _data !== void 0 ? _data : 0, 2),
                            " USD"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* Tabs */.mQ, {
                mb: "16px",
                index: pathInfo.strategyView === "withdraw" ? 1 : 0,
                onChange: function(index) {
                    var // switch to default token (see PRD)
                    _obj, ref;
                    var strategyView = index ? "withdraw" : "deposit";
                    (0,urlHistory/* pushRouterWithoutRerender */.C)(paths/* pathDict.cro.strategy */.o$.cro.strategy[strategyView]);
                    (ref = (_obj = useStrategyStore.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
                },
                role: "heading",
                "aria-label": "strategy vaults",
                "aria-level": 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* TabList */.td, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* Tab */.OK, {
                                children: t("Deposit")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* Tab */.OK, {
                                children: t("Withdraw")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(tabs_dist_index_esm/* TabPanels */.nP, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanel */.x4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DepositContent, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(tabs_dist_index_esm/* TabPanel */.x4, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WithdrawContent, {})
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var DepositContent = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var amountStr = useStrategyStore(function(s) {
        return s.amountStr;
    });
    var amountInputError = useStrategyStore(function(s) {
        return s.amountInputError;
    });
    var depositToken = useStrategyStore(function(s) {
        return s.depositToken;
    });
    var openDepositDrawer = (0,useDepositDrawer/* useDepositDrawer */.t)(function(s) {
        return s.onOpen;
    });
    var depositTransactionFee = useStrategyDepositTransactionFee(depositToken);
    var tokenInfo = strategy/* LiquidityStrategyTokenDict */.qn[depositToken];
    /**
   * todo cover.lv mock
   */ var apy = 0.24;
    /**
   * todo cover.lv mock
   */ var apyList = [
        {
            y: 0.1,
            date: Date.now()
        },
        {
            y: 1.2,
            date: Date.now()
        }, 
    ];
    var depositFee = 0;
    var balanceRet = (0,strategy/* useDepositTokenBalances */.XW)()[depositToken];
    var balanceUsd = (0,strategy/* useDepositTokenBalanceUsd */.AD)({
        token: depositToken,
        amount: balanceRet.data
    });
    var amountUsd = (0,strategy/* useDepositTokenBalanceUsd */.AD)({
        token: depositToken,
        amount: (0,format/* parseValue */.H2)(amountStr, strategy/* LiquidityStrategyTokenDict */.qn[depositToken].decimals)
    });
    var maxAmount = (0,react.useMemo)(function() {
        var balance = balanceRet.data ? (0,bigNumberToNumber/* default */.Z)(balanceRet.data) : 0;
        if (!depositTransactionFee) return 0;
        if (depositTransactionFee.lte(0)) return balance;
        return parseFloat((0,lib_esm.formatEther)((0,lib_esm.parseEther)(balance.toString()).sub(depositTransactionFee)));
    }, [
        balanceRet.data,
        depositTransactionFee
    ]);
    var onChange = function(value) {
        useStrategyStore.setState({
            amountStr: value,
            amountInputError: decimalsValidator(value) || balanceValidator(value, maxAmount)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                title: t("{coin} Wallet Balance", {
                    coin: tokenInfo.name
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(tokenInfo.Icon, {
                    width: "32px",
                    height: "32px"
                }),
                amount: balanceRet.data,
                usdAmount: balanceUsd,
                usdDisplayDecimals: 3,
                showUsdAmount: true,
                mt: "16px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StrategyApySimpleLineChart/* StrategyApySimpleLineChart */.p, {
                apyList: apyList,
                mt: "30px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                title: t("Liquidity strategy APY"),
                value: (0,format/* formatPercentage */.rl)(apy),
                mt: "40px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: "16px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCardStepper/* InputCardStepper */.m, {
                        max: maxAmount,
                        maxDecimals: tokenInfo.maxDecimals,
                        value: amountStr,
                        onChange: onChange,
                        mb: "6px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard/* InputBox */.W, {
                                flex: "1",
                                max: maxAmount,
                                maxDecimals: tokenInfo.maxDecimals,
                                label: t("Input {coin} amount", {
                                    coin: tokenInfo.name
                                }),
                                value: amountStr,
                                onChange: onChange,
                                errorMessage: amountInputError,
                                warningMessage: amountStr === String(maxAmount) && depositToken === "cro" ? t("Gas fee has been deducted from maximum balance") : undefined,
                                usdValue: amountUsd ? (0,bigNumberToNumber/* default */.Z)(amountUsd) : undefined
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectionButton, {
                                width: "82px",
                                value: depositToken,
                                onChange: function(depositToken) {
                                    useStrategyStore.setState({
                                        depositToken: depositToken,
                                        amountStr: "",
                                        amountInputError: ""
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                w: "full",
                disabled: !amountStr || !!amountInputError,
                onClick: function() {
                    openDepositDrawer({
                        isWithdraw: false,
                        token: depositToken,
                        amountStr: amountStr
                    });
                    useStrategyStore.setState({
                        amountStr: "",
                        amountInputError: ""
                    });
                },
                mt: "16px",
                children: t("Deposit {coin}", {
                    coin: tokenInfo.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveRows/* ReceiveRows */.Z, {
                isWithdraw: false,
                token: depositToken,
                amountStr: amountStr,
                mt: "28px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                title: t("Deposit Fee"),
                value: (0,format/* formatPercentage */.rl)(depositFee),
                mt: "16px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                p: "10px 8px",
                mt: "28px",
                bg: "brand-white",
                rounded: "4px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        as: "span",
                        textStyle: "bodyBold",
                        color: "warning",
                        children: "Attention:"
                    }),
                    " ",
                    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
                ]
            })
        ]
    });
};
var WithdrawContent = function() {
    var t = (0,i18n/* useTranslations */.T_)();
    var withdrawStr = useStrategyStore(function(s) {
        return s.withdrawStr;
    });
    var withdrawInputError = useStrategyStore(function(s) {
        return s.withdrawInputError;
    });
    var withdrawToken = useStrategyStore(function(s) {
        return s.withdrawToken;
    });
    var openDepositDrawer = (0,useDepositDrawer/* useDepositDrawer */.t)(function(s) {
        return s.onOpen;
    });
    var vaultBalanceRet = (0,strategy/* useVaultBalance */.KR)(withdrawToken);
    var balanceBn = (0,strategy/* useTokenAssetsFromShares */.Gi)(withdrawToken, vaultBalanceRet.data);
    var balanceUsd = (0,strategy/* useDepositTokenBalanceUsd */.AD)({
        token: withdrawToken,
        amount: balanceBn
    });
    var withdrawAmountUsd = (0,strategy/* useDepositTokenBalanceUsd */.AD)({
        token: withdrawToken,
        amount: (0,format/* parseValue */.H2)(withdrawStr, strategy/* LiquidityStrategyTokenDict */.qn[withdrawToken].decimals)
    });
    var tokenInfo = strategy/* LiquidityStrategyTokenDict */.qn[withdrawToken];
    var maxAmount = balanceBn ? (0,bigNumberToNumber/* default */.Z)(balanceBn) : 0;
    var withdrawFee = 0;
    var onChange = function(value) {
        useStrategyStore.setState({
            withdrawStr: value,
            withdrawInputError: decimalsValidator(value) || balanceValidator(value, maxAmount)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Balance/* default */.Z, {
                title: t("{coin} deposit balance", {
                    coin: tokenInfo.name
                }),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(tokenInfo.Icon, {
                    width: "32px",
                    height: "32px"
                }),
                amount: balanceBn,
                usdAmount: balanceUsd,
                usdDisplayDecimals: 3,
                showUsdAmount: true,
                mt: "16px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                mt: "32px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCardStepper/* InputCardStepper */.m, {
                        max: maxAmount,
                        maxDecimals: tokenInfo.maxDecimals,
                        value: withdrawStr,
                        onChange: onChange,
                        mb: "6px"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                        gap: "8px",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InputCard/* InputBox */.W, {
                                flex: "1",
                                max: maxAmount,
                                maxDecimals: tokenInfo.maxDecimals,
                                label: t("Input {coin} amount", {
                                    coin: tokenInfo.name
                                }),
                                value: withdrawStr,
                                onChange: onChange,
                                errorMessage: withdrawInputError,
                                usdValue: withdrawAmountUsd ? (0,bigNumberToNumber/* default */.Z)(withdrawAmountUsd) : undefined
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TokenSelectionButton, {
                                width: "82px",
                                value: withdrawToken,
                                onChange: function(withdrawToken) {
                                    useStrategyStore.setState({
                                        withdrawToken: withdrawToken
                                    });
                                },
                                preferred: "ferroLP"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                w: "full",
                disabled: !withdrawStr || !!withdrawInputError,
                onClick: function() {
                    openDepositDrawer({
                        isWithdraw: true,
                        token: withdrawToken,
                        amountStr: withdrawStr
                    });
                    useStrategyStore.setState({
                        withdrawStr: "",
                        withdrawInputError: ""
                    });
                },
                mt: "16px",
                children: t("Withdraw {coin}", {
                    coin: tokenInfo.name
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ReceiveRows/* ReceiveRows */.Z, {
                isWithdraw: true,
                token: withdrawToken,
                amountStr: withdrawStr,
                mt: "28px"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Info/* default */.Z, {
                title: t("Withdrawal Fee"),
                value: (0,format/* formatPercentage */.rl)(withdrawFee),
                mt: "16px"
            })
        ]
    });
};


/***/ }),

/***/ 66490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ useDepositDrawer; }
/* harmony export */ });
/* harmony import */ var _ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7306);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32848);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14990);



var useDepositDrawer = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* .create */ .Ue)((0,_ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__/* .resetWhenRouterChange */ .G)(function(set) {
    return {
        isOpen: false,
        onOpen: function(param) {
            var amountStr = param.amountStr, isWithdraw = param.isWithdraw, token = param.token;
            set({
                isOpen: true,
                amountStr: amountStr,
                isWithdraw: isWithdraw,
                token: token
            });
        },
        onClose: function() {
            var _obj, ref;
            (ref = (_obj = useDepositDrawer.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
        },
        isWithdraw: false,
        step: _utils__WEBPACK_IMPORTED_MODULE_1__/* .LiquidityStrategyStep["default"] */ .XT["default"],
        amountStr: "",
        token: "wcro",
        pendingNSteps: 1,
        pendingCurrentStep: 1,
        errorCode: "",
        errorMessage: "",
        receivedAmount: undefined
    };
}));


/***/ }),

/***/ 14990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qc": function() { return /* binding */ useWithdraw; },
/* harmony export */   "Qo": function() { return /* binding */ useDeposit; },
/* harmony export */   "XT": function() { return /* binding */ LiquidityStrategyStep; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61706);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45813);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86599);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30235);
/* harmony import */ var _ui_utils_format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25966);
/* harmony import */ var _ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92786);
/* harmony import */ var _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95142);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70079);
/* harmony import */ var _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66490);
/* eslint-disable @typescript-eslint/ban-ts-comment */ 







var LiquidityStrategyStep;
(function(LiquidityStrategyStep) {
    LiquidityStrategyStep[LiquidityStrategyStep["default"] = 0] = "default";
    LiquidityStrategyStep[LiquidityStrategyStep["pending"] = 1] = "pending";
    LiquidityStrategyStep[LiquidityStrategyStep["success"] = 2] = "success";
    LiquidityStrategyStep[LiquidityStrategyStep["failed"] = 3] = "failed";
})(LiquidityStrategyStep || (LiquidityStrategyStep = {}));
var useDeposit = function() {
    var token = (0,_useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer */ .t)(function(s) {
        return s.token;
    });
    var amountStr = (0,_useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer */ .t)(function(s) {
        return s.amountStr;
    });
    var client = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    var account = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount();
    var vaultSdk = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useVaultSdk */ .sP)(token);
    var tokenSdk = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useTokenSdk */ .SO)(token);
    var refetchVault = useRefetchVault(token);
    var amountBn = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return (0,_ui_utils_format__WEBPACK_IMPORTED_MODULE_0__/* .parseValue */ .H2)(amountStr, 18);
    }, [
        amountStr
    ]);
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var allowance, approveTransaction, transaction, receipt, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!vaultSdk || !tokenSdk || !account) {
                        return [
                            2
                        ];
                    }
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.pending
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        tokenSdk.allowance(account, vaultSdk.contractAddress)
                    ];
                case 2:
                    allowance = _state.sent();
                    if (!allowance.lt(amountBn)) return [
                        3,
                        5
                    ];
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        pendingNSteps: 2,
                        pendingCurrentStep: 1
                    });
                    return [
                        4,
                        tokenSdk.approve(vaultSdk.contractAddress, amountBn)
                    ];
                case 3:
                    approveTransaction = _state.sent();
                    return [
                        4,
                        approveTransaction.txReceiptPromise
                    ];
                case 4:
                    _state.sent();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        pendingCurrentStep: 2
                    });
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        vaultSdk.deposit(amountBn, account)
                    ];
                case 6:
                    transaction = _state.sent();
                    return [
                        4,
                        transaction.txReceiptPromise
                    ];
                case 7:
                    receipt = _state.sent();
                    refetchVault();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.success,
                        receivedAmount: vaultSdk.getDepositReceivedAmount(receipt, account)
                    });
                    client.invalidateQueries([
                        "useVaultExchangeRate"
                    ]);
                    client.invalidateQueries([
                        "useVaultBalance"
                    ]);
                    return [
                        3,
                        9
                    ];
                case 8:
                    err = _state.sent();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.failed,
                        errorCode: err.code,
                        errorMessage: err.message || ""
                    });
                    throw err;
                case 9:
                    return [
                        2
                    ];
            }
        });
    }));
};
var useWithdraw = function() {
    var client = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_5__/* .useQueryClient */ .NL)();
    var token = (0,_useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer */ .t)(function(s) {
        return s.token;
    });
    var amountStr = (0,_useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer */ .t)(function(s) {
        return s.amountStr;
    });
    var account = _veno_app_wallet__WEBPACK_IMPORTED_MODULE_2__/* .currentWallet.useAccount */ .AX.useAccount();
    var vaultSdk = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useVaultSdk */ .sP)(token);
    var refetchVault = useRefetchVault(token);
    var tokenInfo = _ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .LiquidityStrategyTokenDict */ .qn[token];
    var withdrawSharesBn = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useSharesFromTokenAssets */ .cO)(token, (0,_ui_utils_format__WEBPACK_IMPORTED_MODULE_0__/* .parseValue */ .H2)(amountStr, tokenInfo.decimals));
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useMutation */ .D)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function() {
        var _tmp, approveTransaction, transaction, receipt, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!vaultSdk || !account || !withdrawSharesBn) {
                        return [
                            2
                        ];
                    }
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.pending
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        9,
                        ,
                        10
                    ]);
                    _tmp = vaultSdk.shouldApproveWhenWithdraw && vaultSdk.approveWhenWithdraw;
                    if (!_tmp) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        vaultSdk.shouldApproveWhenWithdraw(account, withdrawSharesBn)
                    ];
                case 2:
                    _tmp = _state.sent();
                    _state.label = 3;
                case 3:
                    if (!_tmp) return [
                        3,
                        6
                    ];
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        pendingNSteps: 2,
                        pendingCurrentStep: 1
                    });
                    return [
                        4,
                        vaultSdk.approveWhenWithdraw(withdrawSharesBn)
                    ];
                case 4:
                    approveTransaction = _state.sent();
                    return [
                        4,
                        approveTransaction.txReceiptPromise
                    ];
                case 5:
                    _state.sent();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        pendingCurrentStep: 2
                    });
                    _state.label = 6;
                case 6:
                    return [
                        4,
                        vaultSdk.withdraw(withdrawSharesBn, account)
                    ];
                case 7:
                    transaction = _state.sent();
                    return [
                        4,
                        transaction.txReceiptPromise
                    ];
                case 8:
                    receipt = _state.sent();
                    refetchVault();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.success,
                        receivedAmount: vaultSdk.getWithdrawReceivedAmount(receipt, account)
                    });
                    client.invalidateQueries([
                        "useVaultExchangeRate"
                    ]);
                    client.invalidateQueries([
                        "useVaultBalance"
                    ]);
                    return [
                        3,
                        10
                    ];
                case 9:
                    err = _state.sent();
                    _useDepositDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useDepositDrawer.setState */ .t.setState({
                        step: LiquidityStrategyStep.failed,
                        errorCode: err.code,
                        errorMessage: err.message || ""
                    });
                    throw err;
                case 10:
                    return [
                        2
                    ];
            }
        });
    }));
};
var useRefetchVault = function(token) {
    var balanceRet = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useDepositTokenBalances */ .XW)({
        enabled: false
    })[token];
    var vaultBalanceRet = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_1__/* .useVaultBalance */ .KR)(token, {
        enabled: false
    });
    return function() {
        balanceRet.refetch();
        vaultBalanceRet.refetch();
    };
};


/***/ }),

/***/ 18902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReceiveRows; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31501);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89874);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66697);
/* harmony import */ var _ui_components_Info_Info__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6967);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68866);
/* harmony import */ var _ui_utils_strategy__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92786);







var ReceiveRows = function(_param) {
    var isWithdraw = _param.isWithdraw, amountStr = _param.amountStr, token = _param.token, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "isWithdraw",
        "amountStr",
        "token"
    ]);
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslations */ .T_)();
    var tokenInfo = _ui_utils_strategy__WEBPACK_IMPORTED_MODULE_3__/* .LiquidityStrategyTokenDict */ .qn[token];
    var exchangeRateRet = (0,_ui_utils_strategy__WEBPACK_IMPORTED_MODULE_3__/* .useVaultExchangeRate */ .l7)(token);
    var receivedAmountFromDeposit = exchangeRateRet.data ? (Number(amountStr) / exchangeRateRet.data).toFixed(2) : null;
    var receivedAmountFromWithdraw = Number(amountStr).toFixed(2);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_Info_Info__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: t("You will receive"),
                value: isWithdraw ? receivedAmountFromWithdraw && !Number.isNaN(receivedAmountFromWithdraw) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                            children: receivedAmountFromWithdraw
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(tokenInfo.Icon, {})
                    ]
                }) : "--" : receivedAmountFromDeposit && !Number.isNaN(receivedAmountFromDeposit) ? "".concat(receivedAmountFromDeposit, " ").concat(tokenInfo.vaultTokenName) : "--"
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_Info_Info__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                title: t("Exchange rate"),
                value: "1 ".concat(tokenInfo.name, " : ").concat(exchangeRateRet.data ? (1 / exchangeRateRet.data).toFixed(4) : "--", " ").concat(tokenInfo.vaultTokenName),
                mt: "16px"
            })
        ]
    });
};


/***/ })

}]);